import { api } from "@/lib/api";

// Fetch only IDs displayed on the current page, in bounded batches.
export async function fetchCultivarsByIds(ids, signal) {
  const unique = [...new Set(ids.filter(Boolean))];
  const batches = [];
  for (let index = 0; index < unique.length; index += 200) {
    batches.push(api.get("/botanical/cultivars", {
      params: { ids: unique.slice(index, index + 200).join(","), limit: 500 }, signal,
    }).then(({ data }) => data));
  }
  return (await Promise.all(batches)).flat();
}

